import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  Typography,
  CircularProgress,
  Button,
} from '@material-ui/core';

import InfoIcon from '@material-ui/icons/InfoOutlined';

import DashboardLayout from '../components/DashboardLayout';
import FeedList from '../components/feed/FeedList';
import Alert from '../../common/components/Alert';
import * as dashboardActions from '../actions';
import classes from '../../css/getCSS';
import * as routes from '../../config/routes';


class Home extends Component {
  componentDidMount() {
    document.title = 'My Feed';
    this.props.getUserFeed(this.props.token);
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    this.props.feedUnmount();
  }

  loadMore = (url) => {
    this.props.getUserFeed(this.props.token, url);
  }

  editProfileSection = (section) => {
    this.props.history.push(
      formatRoute(
        routes.EDIT_PROFILE,
        { section: section }, // eslint-disable-line
      ),
    );
  }

  render() {
    let feed = null;

    if (this.props.feed.length > 0) {
      feed = (
        <FeedList
          feed={this.props.feed}
          count={this.props.count}
          next={this.props.next}
          loadMore={this.loadMore}
        />
      );
    }

    let loading = null;

    if (this.props.loading) {
      loading = (
        <div align="center" style={{ marginTop: '50px' }}>
          <CircularProgress align="center" size={50} /> <br />
          <Typography variant="body1">Loading. Please wait</Typography>
        </div>
      );
    }

    let errorAlert = null;
    if (this.props.error) {
      errorAlert = <Alert type="danger">{this.props.error}</Alert>;
    }

    let partnerAlert = null;
    if (!this.props.user.has_partner_choice) {
      partnerAlert = (
        <Alert type="grey">
          <Typography variant="subheading" style={{ color: '#fff', fontWeight: 'bold', fontSize: '20px' }}>
            <InfoIcon style={{ verticalAlign: 'middle', fontSize: '18px' }} /> Tip
          </Typography>
          <Typography variant="subheading" style={{ color: '#fff' }}>
            {'Add your partner\'s choice to help prospective matches know your interests'}
          </Typography>
          <Button onClick={() => this.editProfileSection('partnerchoice')} style={{ marginTop: '10px' }} size="small" variant="contained">{'Add Partner\'s Choice'}</Button>
        </Alert>
      );
    }

    return (
      <DashboardLayout
        isAuthenticated
        activeLink="home"
        dashActiveLink="feed"
        user={this.props.user}
      >
        <div className={[classes.padding10XS, classes.padding10SM].join(' ')} style={{ marginBottom: '10px' }}>
          <Typography variant="headline">My Activity Feed</Typography>
          <Typography variant="caption">Here you will see all updates related to your profile since your signup</Typography>
          <Typography variant="caption">Only you can see this feed</Typography>
        </div>
        {partnerAlert}
        {feed}
        {loading}
        {errorAlert}
      </DashboardLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    user: state.auth.user,
    loading: state.dashboard.loading,
    feed: state.dashboard.feed,
    count: state.dashboard.count,
    next: state.dashboard.next,
    error: state.dashboard.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserFeed: (token, url) => dispatch(dashboardActions.getUserFeed(token, url)),
    feedUnmount: () => dispatch(dashboardActions.feedUnmount()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));



// WEBPACK FOOTER //
// ./src/dashboard/containers/Home.js